import ConsigneeDashboard from "@/pages/consignee/index.vue";
import ConsigneeTrip from "@/pages/consignee/trip/ConsigneeTrip.vue";
import ConsigneeOrderDetails from "@/components/ModuleBasedComponents/Consignee/ConsigneeOrderDetails.vue";

export default [
  {
    path: "consignee-dashboard",
    name: "consignee-dashboard",
    component: ConsigneeDashboard,
  },
  {
    path: "consignee-trip",
    name: "consignee-trip",
    component: ConsigneeTrip,
  },
  {
    path: "consignee-order-details",
    name: "consignee-order-details",
    component: ConsigneeOrderDetails,
  },
];
